import React from 'react'
import { CellProps, CellRenderer } from '../../legacy-design-system/grid'
import { LoadingTextMask } from '../../legacy-design-system/loading-masks'
import { readOnlyGridCss } from '../../legacy-design-system/text'
import { FormattedRelativeTime, FormattedTime, FormattedDate } from 'react-intl'
import { css, cx } from '@emotion/css'
import { WithTooltip } from '../../design-system'
import { selectRelativeUnits } from '../react-intl-helpers'

const cellCss = css`
  padding: 8px;
`

interface RowData {
  lastActivity: string
  firstActivity: string
}

export const lastSeenCellRenderer: CellRenderer<RowData> = ({
  rowData: { lastActivity },
  getCellContentProps
}) => {
  return (
    <SeenCellRenderer
      seen={lastActivity}
      getCellContentProps={getCellContentProps}
    ></SeenCellRenderer>
  )
}

export const firstSeenCellRenderer: CellRenderer<RowData> = ({
  rowData: { firstActivity },
  getCellContentProps
}) => {
  return (
    <SeenCellRenderer
      seen={firstActivity}
      getCellContentProps={getCellContentProps}
    ></SeenCellRenderer>
  )
}

export const SeenCellRenderer = ({
  seen,
  getCellContentProps
}: {
  seen: string
  getCellContentProps: CellProps<RowData>['getCellContentProps']
}) => {
  const date = new Date(Number.parseInt(seen, 10))
  const { value, unit } = selectRelativeUnits(date)

  return (
    <WithTooltip
      dataTestId={`seen-tooltip-${seen}`}
      tiny={true}
      renderTooltipContent={() => (
        <FormattedDate value={date}>
          {(dateText) => (
            <FormattedTime value={date}>
              {(timeText) => <span>{`${dateText} ${timeText}`}</span>}
            </FormattedTime>
          )}
        </FormattedDate>
      )}
      children={() => (
        <div
          data-testid={`seen-${seen}`}
          {...getCellContentProps({ className: cellCss })}
        >
          {Number.isNaN(value) ? (
            <span className={readOnlyGridCss}>{date.toString()}</span>
          ) : (
            <FormattedRelativeTime value={value} unit={unit} numeric="auto">
              {(text) => <span className={readOnlyGridCss}>{text}</span>}
            </FormattedRelativeTime>
          )}
        </div>
      )}
    />
  )
}

const loadingCellCss = cx(
  cellCss,
  css`
    width: 100%;
  `
)

export function loadingSeenCell() {
  return (
    <span className={loadingCellCss}>
      <LoadingTextMask min={4} max={6} />
    </span>
  )
}
